export default class Magazzino{
    CodiceMagazzino;
    DescrizioneMagazzino;

    constructor(){}
}